// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 9175) return "static/chunks/9175-b8c151811c224125.js";
	if (chunkId === 7568) return "static/chunks/7568-8e712dc27fd156be.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"579":"ed0b6a0974d5cc97","1856":"e9fbf4227216c55f","2688":"5fe0677850db8ba5","4912":"eddec16756ada6d1","7871":"384dbee01ee9fca0","9390":"ed1c4f95b3c8b5fc"}[chunkId] + ".js";
};